export default class Version {
  constructor(v) {
    this.val = v.toString();

    if (!this.val.match(/^([^.]+\.)*[^.]+$/) || this.val.match(/^[^\d\w]|\.[^\d\w]|[^\d\w]$/i)) {
      throw new Error('invalid version');
    }
  }

  gt(v) {
    return Version.compare(this.val, v) > 0;
  }

  gte(v) {
    return Version.compare(this.val, v) >= 0;
  }

  lt(v) {
    return Version.compare(this.val, v) < 0;
  }

  lte(v) {
    return Version.compare(this.val, v) <= 0;
  }

  eq(v) {
    return Version.compare(this.val, v) === 0;
  }

  toString() {
    return this.val;
  }

  static compare(v1, v2) {
    const val1 = v1.toString().split('.');
    const val2 = v2.toString().split('.');

    for (let i = 0; i < val1.length || i < val2.length; i += 1) {
      let n1 = parseInt(val1[i], 10);
      let n2 = parseInt(val2[i], 10);

      // eslint-disable-next-line
      if (isNaN(n1)) {
        n1 = 0;
      }
      // eslint-disable-next-line
      if (isNaN(n2)) {
        n2 = 0;
      }
      if (n1 < n2) {
        return -1;
      } if (n1 > n2) {
        return 1;
      }
    }
    return 0;
  }
}
